import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function setAdminToken(token) {
  if (token) localStorage.setItem("saircos_admin_token", token);
  else localStorage.removeItem("saircos_admin_token");
}
export function getAdminToken() {
  return localStorage.getItem("saircos_admin_token");
}
export function adminApi() {
  return axios.create({
    baseURL: API,
    headers: { Authorization: `Bearer ${getAdminToken()}` },
  });
}

function formatApiError(detail) {
  if (detail == null) return "Errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      setAdminToken(data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-slate-900 border border-slate-700 px-4 py-3 text-sm text-white focus:outline-none focus:border-blue-500 font-mono placeholder:text-slate-500";

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-6">
      <div className="w-full max-w-md border border-slate-700 bg-slate-900 p-8">
        <div className="flex justify-center mb-6">
          <div className="bg-white px-4 py-2">
            <img src="/assets/logo.png" alt="Saircos" className="h-10 w-auto" />
          </div>
        </div>
        <h1 className="text-xl font-extrabold uppercase text-white text-center">Area Riservata</h1>
        <p className="text-xs text-slate-400 font-mono text-center mt-2 mb-8">Gestione cantieri e schede tecniche</p>
        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="block text-xs font-mono uppercase text-slate-300 mb-2">Email</label>
            <input data-testid="admin-login-email" type="email" required className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@saircos-spa.it" />
          </div>
          <div>
            <label className="block text-xs font-mono uppercase text-slate-300 mb-2">Password</label>
            <input data-testid="admin-login-password" type="password" required className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="text-xs font-mono text-red-400">{error}</p>
          )}
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full px-8 py-4 bg-blue-600 hover:bg-blue-500 text-white font-bold uppercase tracking-widest text-xs transition-colors disabled:opacity-60 inline-flex items-center justify-center gap-2">
            {loading && <Loader2 className="animate-spin" size={14} />}
            {loading ? "Accesso..." : "Accedi"}
          </button>
        </form>
        <a href="/" className="block text-center mt-6 text-xs font-mono text-slate-400 hover:text-blue-400 transition-colors">← Torna al sito</a>
      </div>
    </div>
  );
}
